import { Injectable } from '@angular/core';
import {
  MatDateRangeSelectionStrategy,
  DateRange,
} from '@angular/material/datepicker';

@Injectable()
export class DateRangeSelectionStrategy<D>
  implements MatDateRangeSelectionStrategy<D> {
  selectionFinished(
    date: D | null,
    currentRange: DateRange<D> | null
  ): DateRange<D> {
    return this._dateRange(date, currentRange);
  }

  createPreview(
    activeDate: D | null,
    currentRange: DateRange<D> | null
  ): DateRange<D> {
    return this._dateRange(activeDate, currentRange);
  }

  private _dateRange(
    activeDate: D | null,
    currentRange: DateRange<D> | null
  ): DateRange<D> {
    // if no date selected
    if (currentRange && !currentRange.start && !currentRange.end) {
      return new DateRange<D>(activeDate, null);
    }
    // if start date selected
    if (currentRange && currentRange.start && !currentRange.end) {
      if (activeDate && activeDate >= currentRange.start) {
        return new DateRange<D>(currentRange.start, activeDate);
      }
      if (activeDate && activeDate <= currentRange.start) {
        return new DateRange<D>(activeDate, currentRange.start);
      }
    }
    // if new start date selected
    if (currentRange && currentRange.start && currentRange.end) {
      return new DateRange<D>(activeDate, null);
    }
    return new DateRange<D>(null, null);
  }
}
